import NoKeysIcon from './NoKeysIcon'

export default NoKeysIcon
